export const DEFAULT_DEBOUNCE_TIME = 500;
export const DEFAULT_DELAY_TIME = 10000;
export const FOOTER_TEXT = 'Powered by Halliburton';
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_REGEX = /[0-9]/;
export const HEX_COLOR_REGEX = /^([0-9a-f]{3}){1,2}$/i;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;